<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              v-model="form.filters.nome"
              label="Setor"
              outlined
              dense
              maxlength="40"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="form.filters.origem"
              label="Origem"
              dense
              outlined
              :item-text="(v) => v.nome.toUpperCase()"
              item-value="id"
              :items="form.lists.origens"
            ></v-select>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.ativo"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarSetores()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Incluir"
              icon="mdi-plus"
              @click="openDialogManterSetor()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.origem`]="{ item }">
          {{ item.origem.toUpperCase() }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Visualizar"
            icon="mdi-eye-outline"
            small
            @click="openDialogVisualizarSetor(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Editar"
            icon="mdi-pencil"
            small
            @click="openDialogManterSetor(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Excluir"
            icon="mdi-delete"
            small
            @click="excluirSetor(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
            small
            @click="alterarStatusSetor(item)"
          ></sigfoco-tooltip>
        </template>
        <template v-slot:[`item.emUso`]="{ item }">
          <sigfoco-tooltip
            :text="'Detalhar Uso'"
            :icon="item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
            :color="item.emUso ? 'green' : 'red'"
            :small="true"
            :disabled="!item.emUso"
            @click="item.emUso ? openDialogDetalharUsoSetor(item) : null"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <VisualizarSetorDialog
      v-if="dialogVisualizarSetor.visible"
      :funcoes="form.lists.funcoes"
      :visible="dialogVisualizarSetor.visible"
      :content="dialogVisualizarSetor.content"
      @onClose="dialogVisualizarSetor.close()"
    ></VisualizarSetorDialog>
    <CadastrarEditarSetorDialog
      v-if="dialogManterSetor.visible"
      :funcoes="form.lists.funcoes"
      :edit="dialogManterSetor.edit"
      :visible="dialogManterSetor.visible"
      :content="dialogManterSetor.content"
      :origens="form.lists.origens"
      @onClose="dialogManterSetor.close()"
      @onSave="buscarSetores()"
    ></CadastrarEditarSetorDialog>
    <DetalharUsoSetorDialog
      :visible="dialogDetalharUsoSetor.visible"
      :content="dialogDetalharUsoSetor.content"
      @onClose="dialogDetalharUsoSetor.close()"
      ></DetalharUsoSetorDialog>
  </div>
</template>

<script>
import { Setor } from "~/commons/classes/setor";
import { Dialog } from "~/commons/classes/dialog";
import ManterSetorService from "~/services/manter-setor.service"
import ManterFuncaoService from "~/services/manter-funcao.service"
import VisualizarSetorDialog from "./dialogs/VisualizarSetorDialog.vue";
import CadastrarEditarSetorDialog from "./dialogs/CadastrarEditarSetorDialog.vue";
import DetalharUsoSetorDialog from "./dialogs/DetalharUsoSetorDialog.vue";
export default {
  name: "ManterSetoresView",
  mixins: [ManterSetorService, ManterFuncaoService],
  components: {
    VisualizarSetorDialog,
    CadastrarEditarSetorDialog,
    DetalharUsoSetorDialog
  },
  data: () => ({
    dialogManterSetor: Dialog.Build(),
    dialogVisualizarSetor: Dialog.Build(),
    dialogDetalharUsoSetor: Dialog.Build(),
    form:{
      filters: {
        nome: null,
        origem: null,
        ativo: null,
      },
      lists: {
        funcoes: [],
        origens: []
      }
    },
    table: {
      headers: [
        { text: "Setor", align: "left", value: "nome" },
        { text: "Origem", align: "left", value: "origem" },
        { text: "Situação", align: "center", value: "ativo", sortable: false },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
        { text: "Em uso", align: "center", value: "emUso", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    buscarFuncoes() {
      const params = { ativo: true};
      this.$buscarFuncoes({params}).then(({ data }) => this.form.lists.funcoes = data.itens)
    },
    buscarOrigens() {
      this.$buscarOrigens({ params: {apenasAtribuiveis: true} }).then(
        ({ data }) => this.form.lists.origens = data.itens
      )
    },
    buscarSetores() {
      this.$buscarSetores({ params: this.form.filters }).then(
        ({ data }) => this.table.itens = data.itens
      )
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    openDialogManterSetor(setor) {
      setor
        ? this.$visualizarSetor(setor.id).then(
          ({ data }) => this.dialogManterSetor.open(new Setor(data.resposta), true))
        : this.dialogManterSetor.open(Setor.Build());
    },
    openDialogVisualizarSetor(setor) {
      this.$visualizarSetor(setor.id).then(
        ({ data }) => this.dialogVisualizarSetor.open(new Setor(data.resposta))
      );
    },
    excluirSetor(setor) {
      this.$swal({
        text: `Deseja confirmar a exclusão do setor?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        if(setor.emUso){
            this.mostrarModalEmUso(setor);
          } else {
              this.$excluirSetor(setor.id).then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarSetores();
            });
          }
        }  
      );
    },
    alterarStatusSetor(setor) {
      this.$swal({
        text: `Deseja confirmar a ${ setor.ativo ? "inativação" : "ativação" } do Setor?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        if (setor.ativo && setor.emUso) {
          this.mostrarModalEmUso(setor);
        } else {
          this.$inativarAtivarSetor(setor.id)
            .then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarSetores();
            });
        }
      });
    },
    mostrarModalEmUso(item) {
      const qtd = item.quantidadeEmUso;
      this.$swal({
        text: `O registro não pode ser inativado ou excluído, pois está em uso em ${qtd} funcionalidade(s).`,
        type: "warning",
        confirmButtonText: "OK",
      });
    },
    openDialogDetalharUsoSetor(setor) {
      this.$detalharUsoSetor(setor).then(
        ({ data }) => (this.dialogDetalharUsoSetor.open(data.resposta))
      );
    },
  },
  mounted() {
    this.buscarFuncoes();
    this.buscarOrigens();
    this.hidePageLoading();
  }
}
</script>